import { RouteConfig } from 'vue-router';
import { RouteName } from '../routes.constants';

export const getGamificationComponent =
    (component: keyof typeof import('../gamification.chunk')) => async () => {
        const chunk = await import(
            /* webpackChunkName: "games" */
            '../gamification.chunk'
        );
        return chunk[component];
    };

export const PromotionsRoutes: RouteConfig[] = [
    {
        name: RouteName.PROMOTIONS,
        path: '',
        component: getGamificationComponent('PromotionsListPage'),
        meta: {
            corexUserRestriction: 'promotions',
        },
    },
    {
        name: RouteName.PROMOTION,
        path: ':slug',
        component: getGamificationComponent('PromotionPage'),
        meta: {
            corexUserRestriction: 'promotions',
        },
    },
];
